import React from "react";
import classNames from "classnames";
import { Icon } from "@accessdev/arc-ui-react";
import { Trans } from "@lingui/react/macro";
import { AuthModalTypes } from "@Src/constants";

const { SIGN_IN, SIGN_UP, PROVIDE_PASSWORD } = AuthModalTypes;

function AuthHeader({
  screen,
  isCompleteProfile,
  isAdminCompleteProfile,
  setAuthScreen,
  setAuthOpen,
  mobile,
}) {
  const renderTitle = () => {
    if (!mobile) return null;

    switch (screen) {
      case SIGN_IN:
        return <Trans>Sign in to start saving!</Trans>;
      default:
        return null;
    }
  };
  const isProvidePasswordScreen = screen === PROVIDE_PASSWORD;

  return (
    <header className="Auth-header">
      {isCompleteProfile && (
        <div className="Auth-HeaderTitle__CompleteProfile">
          <h1 className={`Auth-headerTitle ${screen}`}>
            <Trans>Almost There!</Trans>
          </h1>
          <span>
            {isAdminCompleteProfile ? (
              <Trans>Review your information and create a password to access your account.</Trans>
            ) : (
              <Trans>Fill in the form to access your savings.</Trans>
            )}
          </span>
        </div>
      )}
      {isProvidePasswordScreen && (
        <div className="Auth-HeaderTitle__CompleteProfile">
          <h1 className={`Auth-headerTitle ${screen}`}>
            <Trans>Almost There!</Trans>
          </h1>
          <span>
            <Trans>Sign in to view your account information.</Trans>
          </span>
        </div>
      )}
      {mobile && !isCompleteProfile && !isProvidePasswordScreen && (
        <div className={`Auth-mobileHeader ${screen}`}>
          {screen !== SIGN_UP && (
            <h1 className={`Auth-headerTitle t-title-large ${screen}`}>{renderTitle()}</h1>
          )}
          <Icon
            icon="close"
            className={`Auth-headerCloseBtn ${screen}`}
            onClick={() => {
              setAuthOpen(false);
            }}
            type="button"
            size="lg"
          />
        </div>
      )}
      {!mobile && !isCompleteProfile && !isProvidePasswordScreen && (
        <div className="Auth-modalTabs">
          <button
            className={classNames("Auth-modalTab", {
              "active t-title-med": screen === SIGN_IN,
              "t-body-large": screen !== SIGN_IN,
            })}
            onClick={() => setAuthScreen(SIGN_IN)}
            role="tab"
          >
            <Trans>Sign In</Trans>
          </button>
          <button
            className={classNames("Auth-modalTab", {
              "active t-title-med": screen === SIGN_UP,
              "t-body-large": screen !== SIGN_UP,
            })}
            onClick={() => setAuthScreen(SIGN_UP)}
            role="tab"
          >
            <Trans>Sign Up</Trans>
          </button>
        </div>
      )}
    </header>
  );
}

export default AuthHeader;
